export default {
  'read-more': 'Read more',
  login: 'login',
  firstpage: 'My first page',
  'en-gb': 'English',
  'fr-fr': 'Français',
  languages: 'Languages'
};
